import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpDialogComponent } from "../help-dialog/help-dialog.component";
import { ActivatedRoute, Router } from '@angular/router';
import { LeadService } from "../services/lead.service";
import { QuestionnaireService } from '../services/questionnaire.service';
import { SystemTablesService } from '../services/system-tables.service';
import { Prefix } from '../phone-number/phone-number.component';
import { UtilService } from '../services/util.service';
import { PrefixNot } from '@angular/compiler';
import { Draft } from '../services/draft.service';
import { OtpService } from '../services/otp.service';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.scss']
})
export class StartPageComponent implements OnInit {
  isAnimated: boolean = false;
  prefixes: Prefix[] = [];
  modalRef: any;
  constructor(private modalService: NgbModal,
    private route: ActivatedRoute,
    private questionnaireService: QuestionnaireService,
    private leadService: LeadService,
    private router: Router,
    private systemTablesService: SystemTablesService,
    public utilService: UtilService,
    private otpService: OtpService,
    private draft: Draft
  ) { }
  explorer = false;
  isDevMode: boolean;
  ngOnInit() {
    // this.getSystemTblPhonePrefixes();
    this.leadService.setParams();
    let queryObjParams = this.route.snapshot.queryParams;
    if (queryObjParams.goToAdvisor === "true") {
      this.navigate('advisor');
    }
    if (queryObjParams.sID === "20") {
      this.leadService.isFromYad2 = "true";
      this.navigate('');

    }
    else {
      this.leadService.isFromYad2 = "false";
    }

    setTimeout(() => {
      this.isAnimated = true;
    }, 100);
    var msie = window.navigator.userAgent.indexOf('MSIE ');
    if (msie > 0) {
      this.explorer = true;
    }
    var trident = window.navigator.userAgent.indexOf('Trident/');
    if (trident > 0) {
      this.explorer = true;
    }

    this.isDevMode = this.utilService.isDevMode();
  }
  navigate(type) {
    if (type === "advisor") {
      this.questionnaireService.setIsAdvisor(true);
      this.otpService.isNewForm = false;
      //navigate to advisor...
      this.router.navigate(["/questionnaire/advisors", 0]);
      this.draft.isAfterStep1 = false;
      this.questionnaireService.setAsmachta("");
      this.questionnaireService.reset("0");
      this.otpService.isNewForm = false;
      this.otpService.phoneOk = false;
      this.otpService.getCode = false;
      this.otpService.hasLoggedInAdvisor = false;
      this.otpService.confirmCode = false;
      this.otpService.nextStatus("start");
      this.questionnaireService.isLoginAdvisor = false;
      this.draft.clearBorrowersArr();
    }
    else if (type === "continue") {
      this.otpService.isNewForm = false;
      this.router.navigate(["login"]);
      this.questionnaireService.setIsAdvisor(false);
      this.draft.ConsultantId = "";
      this.draft.ConsultFirmId = "";
      this.draft.isAfterStep1 = false;
      this.questionnaireService.setAsmachta("");
      this.questionnaireService.reset("1");
      this.otpService.isNewForm = false;
      this.otpService.phoneOk = false;
      this.otpService.getCode = false;
      this.otpService.confirmCode = false;
      this.otpService.hasLoggedInAdvisor = false;
      this.otpService.nextStatus("start");
      this.draft.clearBorrowersArr();
    }

    else {
      this.otpService.isNewForm = true;
      this.otpService.phoneOk = false;
      this.otpService.getCode = false;
      this.otpService.confirmCode = false;
      this.otpService.hasLoggedInAdvisor = false;
      this.questionnaireService.setIsAdvisor(false);
      this.otpService.nextStatus("start");
      this.router.navigate(["/questionnaire/user-details", 1]);
      this.draft.ConsultantId = "";
      this.draft.ConsultFirmId = "";
      let isAdvisor = this.questionnaireService.getIsAdvisor();
      this.draft.isAfterStep1 = false;
      this.questionnaireService.setAsmachta("");
      this.questionnaireService.reset("1");
      this.draft.clearBorrowersArr();
    }
  }

  openHelpDialog() {
    this.modalRef = this.modalService.open(HelpDialogComponent);
    // .result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }

  goToPrivacyDisclaimerLink() {
      window.location.href = "https://www.mizrahi-tefahot.co.il/about-mizrahi-tefahot-he/conditions-privacy-policy"
  }

  // getSystemTblPhonePrefixes() {

  //   this.systemTablesService.getTable("706").subscribe(
  //     (data: any) => {
  //       console.log("GAL-->data", data)
  //       if (data && data.length > 0) {
  //         this.systemTablesService.setPhonePrefixes(this.filterPrefix(data));
  //         console.log("get system tables succseeded");
  //       }
  //       else if (data.errorCode) {
  //         console.log("get system tables error errorCode: " + data.errorCode);
  //       }
  //       else {
  //         console.log("get system tables error");
  //       }
  //     },
  //     error => {
  //       console.log("get system tables error: " + error);
  //     }

  //   );
  // }
  // filterPrefix(data: Prefix[]): any {
  //   if (!data) {
  //     return;
  //   }
  //   return data.filter(prefix => prefix.mtext.match(/\d+/g) && prefix.mtext.replace(/[^0-9]/g, "").length > 2).map(p => p.mtext);
  // }
}


// WEBPACK FOOTER //
// ./src/app/start-page/start-page.component.ts